<!--
//================================================================================
// ID:BC052
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC052
//
// <<Modification History>>
// Version  | Date       | Updated By			| Content
// ---------+------------+-----------------------+--------------------------------
// 01.02.00 | 2022/10/11 | 富士通Japan株式会社	 | 新規作成
// 01.03.00 | 2023/02/13 | 富士通Japan株式会社   | 令和4年度改修対応（3次リリース）
// 01.04.00 | 2023/09/27 | 富士通Japan株式会社   | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<error-message/>
		<div>
			<main>
				<div class="contents__input-main">
					<div class="contents__title">
						<label class="contents__title--label"></label>
					</div>
					<br>
					<section>
						<h2 class="contents__h2 bosyujyutaku__title">募集住宅情報</h2>
						<table class="contents__table--stripe detail">
							<tbody>
								<tr>
									<th class="contents__input--title">募集の種類</th>
									<td class="width-bosyu-kind">
										<label>随時募集（先着順）</label>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title">住宅の種別
										<span v-show="disp.jutakuKindHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.jyutakuKindNm }}</label>
										</div>
										<div v-show="disp.jyutakuKindEdit" class="marginTop22px">
											<list-box
												class="contents__input--select width-jyutaku"
												:modelValue="form.jyutakuKind"
												:name="'住宅の種別'"
												:groupId="'jyutakuKindInfo'"
												:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
												:cdType="'L0002'"
												:cdHanyo2="'4'"
												:requireFlg="true"
												@update:modelValue="changeJyutakuKind"
												ref="jyutakuKind"
												tabindex="1" />
											<itemerror-message :groupId="'jyutakuKindInfo'"/>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title">公募年月
										<span v-show="disp.ymBosyuHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.ymBosyuYear }}年{{ form.ymBosyuMonth }}月</label>
										</div>
										<div v-show="disp.ymBosyuEdit" class="marginTop22px">
											<year-month-input
												:modelValue="form.ymBosyu"
												:name="'公募年月'"
												:groupId="'ymBosyu'"
												:requireFlg="true"
												@update:modelValue="form.ymBosyu = $event"
												ref="ymBosyu"
												tabindex="2" />
											<itemerror-message :groupId="'ymBosyu'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">申込地区番号</th>
									<td class="width-bosyu-kind">
										<label>{{ form.noMouchikuLbl }}</label>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">入居人数
										<span v-show="disp.cdNyukyoHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.cdNyukyoLbl }}</label>
										</div>
										<div v-show="disp.cdNyukyoEdit" class="marginTop22px">
											<list-box
												class="contents__input--select width-koubo"
												:modelValue="form.cdNyukyo"
												:name="'入居人数'"
												:listItems="disp.cdNyukyoList"
												:groupId="'cdNyukyo'"
												:requireFlg="true"
												@update:modelValue="form.cdNyukyo = $event"
												ref="cdNyukyo"
												tabindex="4" />
											<itemerror-message :groupId="'cdNyukyo'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">区市町
										<span v-show="disp.cdKusicyosonHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.cdKusicyosonLbl }}</label>
										</div>
										<div v-show="disp.cdKusicyosonEdit" class="marginTop22px">
											<div>
												<div class="contents__input--radio">
													<radio-button
														:modelValue="form.kusibu"
														:listItems="disp.kusibuList"
														:name="'区市部ラジオ'"
														:radioGroupName="'kusibu'"
														:groupId="'kusibu'"
														:requireFlg="true"
														@update:modelValue="form.kusibu = $event"
														ref="kusibu"
														tabindex="5"
													/>
													<itemerror-message :groupId="'kusibu'"/>
												</div>
											</div>
											<div>
												<list-box
													class="contents__input--select width-kushicyo"
													:modelValue="form.lstKuSibu"
													:name="'区市町'"
													:groupId="'lstKuSibu'"
													:cdType="'L0013'"
													:cdHanyo1="form.kusibu"
													:requireFlg="true"
													@update:modelValue="form.lstKuSibu = $event"
													ref="lstKuSibu"
													tabindex="7" />
												<itemerror-message :groupId="'lstKuSibu'"/>
											</div>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">団地区分
										<span v-show="disp.cdDanchiHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.cdDanchiLbl }}</label>
										</div>
										<div v-show="disp.cdDanchiEdit" class="marginTop22px">
											<number-input
												class="contents__input--text width-mouchiku input-number ime-inactive textalign-dantikubun"
												style="ime-mode: active"
												:modelValue="form.cdDanchi"
												:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
												:maxLength="5"
												:name="'団地区分'"
												:groupId="'cdDanchi'"
												:requireFlg="true"
												@update:modelValue="form.cdDanchi = $event"
												ref="cdDanchi"
												tabindex="8"
											/>
											<itemerror-message :groupId="'cdDanchi'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">住宅名
										<span v-show="disp.txJutakuNameHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label>{{ form.txJyutakuNameLbl }}</label>
										</div>
										<div v-show="disp.txJutakuNameEdit" class="marginTop22px">
											<text-input
												class="contents__input--text width-jyutaku-text ime-inactive"
												:modelValue="form.txJyutakuName"
												:maxLength="30"
												:textType="TEXTINPUT_TYPE.ALL"
												:name="'住宅名'"
												:groupId="'txJyutakuName'"
												:requireFlg="true"
												@update:modelValue="form.txJyutakuName = $event"
												ref="txJyutakuName"
												tabindex="9" />
											<itemerror-message :groupId="'txJyutakuName'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">代表的な所在地
										<span v-show="disp.txKusicyoHissu" class="contents__hissu">必須</span>
									</th>
									
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label>{{ form.txKusicyoLbl }}</label>
										</div>
										<div v-show="disp.txKusicyoEdit" class="marginTop22px">
											<text-input
												class="contents__input--text width-kushicyo-text ime-inactive"
												:modelValue="form.txKusicyo"
												:maxLength="30"
												:textType="TEXTINPUT_TYPE.ALL"
												:name="'代表的な所在地'"
												:groupId="'txKusicyo'"
												:requireFlg="true"
												@update:modelValue="form.txKusicyo = $event"
												ref="txKusicyo"
												tabindex="10" />
											<itemerror-message :groupId="'txKusicyo'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">外部マップサービスのリンク先</th>
									<td class="padding__top-zero">
										<div class="label-line-height contents__kaigyo--css">
											<label>{{ form.txMapLinkLbl }}</label>
										</div>
										<div v-show="disp.txMapLinkEdit" class="marginTop22px">
											<text-input
												class="contents__input--text width-kushicyo-text ime-inactive"
												:modelValue="form.txMapLink"
												:maxLength="500"
												:textType="TEXTINPUT_TYPE.HALF"
												:name="'外部マップサービスのリンク先'"
												:groupId="'txMapLink'"
												@update:modelValue="form.txMapLink = $event"
												ref="txMapLink"
												tabindex="11" />
											<itemerror-message :groupId="'txMapLink'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">主な交通機関
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label v-if="form.txTransLbl != null">{{ form.txTransLbl }}</label>
											<label v-else class="hidden-word">主な交通機関</label>
										</div>
										<div v-show="disp.txTransEdit" class="marginTop22px">
											<textarea-input
												class="contents__input--text width-textarea ime-active"
												:modelValue="form.txTrans"
												:maxLength="70"
												:name="'主な交通機関'"
												:groupId="'txTrans'"
												:requireFlg="true"
												@update:modelValue="form.txTrans = $event"
												ref="txTrans"
												tabindex="12" />
											<itemerror-message :groupId="'txTrans'"/>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">徒歩区分
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.kbTohoLbl != null">{{ form.kbTohoLbl }}</label>
											<label v-else class="hidden-word">徒歩区分</label>
										</div>
										<div v-show="disp.kbTohoEdit" class="marginTop22px">
											<list-box
												class="contents__input--select width-madori"
												:modelValue="form.kbToho"
												:name="'徒歩区分'"
												:groupId="'kbToho'"
												:requireFlg="true"
												:cdType="'L0033'"
												@update:modelValue="form.kbToho = $event"
												ref="kbToho"
												tabindex="13" />
											<itemerror-message :groupId="'kbToho'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">駅・バス停からの徒歩時間
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.nuTohoLbl != null">{{ form.nuTohoLbl }}分</label>
											<label v-else class="hidden-word">駅・バス停からの徒歩時間</label>
										</div>
										<div v-show="disp.nuTohoEdit" class="marginTop22px">
											<number-input
												class="contents__input--text width-toho-text input-number ime-inactive"
												:modelValue="form.nuToho"
												:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
												:name="'駅・バス停からの徒歩時間'"
												:groupId="'nuToho'"
												:requireFlg="true"
												:maxLength="2"
												@update:modelValue="form.nuToho = $event"
												ref="nuToho"
												tabindex="14"
											/>分
											<itemerror-message :groupId="'nuToho'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">バスの利用有無
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="busUmu-title">
										<div class="marginTop15px">
											<label v-if="form.fgbusRiyouLbl != null">{{ form.fgbusRiyouLbl }}</label>
											<label v-else class="hidden-word">バスの利用有無</label>
										</div>
										<div v-show="disp.fgbusRiyouEdit" class="marginTop22px">
											<div class="contents__input--toggle_btn width-busUmu">
												<toggle-button
													:classDiv="'padding__bottom-toggle'"
													:modelValue="form.fgbusRiyou"
													:name="'バスの利用有無'"
													:cdType="'L0034'"
													:groupId="'fgbusRiyou'"
													:requireFlg="true"
													:radioGroupName="'fgbusRiyou'"
													@update:modelValue="form.fgbusRiyou = $event"
													ref="fgbusRiyou"
													tabindex="15" />
												<itemerror-message :groupId="'fgbusRiyou'"/>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">募集戸数
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.nuBosyuKosuLbl }}戸</label>
										</div>
										<div v-show="disp.nuBosyuKosuEdit" class="marginTop22px">
											<input
												type="button"
												class="contents__btn--plusminus marginRight-bosyuKosu"
												value="－"
												:tabindex="16"
												v-on:click="clickMinus()">
											<number-input
												class="contents__input--text input-number width-bosyuKosu"
												:modelValue="form.nuBosyuKosu"
												:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
												:name="'募集戸数'"
												:groupId="'nuBosyuKosu'"
												:requireFlg="true"
												:maxLength="3"
												@update:modelValue="form.nuBosyuKosu = $event"
												ref="nuBosyuKosu"
												tabindex="17"
											/>
											<input
												type="button"
												class="contents__btn--plusminus marginLeft-bosyuKosu"
												value="＋"
												:tabindex="18"
												v-on:click="clickPlus()">戸
											<itemerror-message :groupId="'nuBosyuKosu'"/>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り１
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.cdMadori1Lbl != null">{{ form.cdMadori1Lbl }}</label>
											<label v-else class="hidden-word">間取り１</label>
										</div>
										<div v-show="disp.cdMadori1Edit" class="marginTop22px">
											<list-box
												class="contents__input--select width-madori"
												:modelValue="form.cdMadori1"
												:name="'間取り１'"
												:groupId="'Madori1'"
												:requireFlg="true"
												:cdType="'L0020'"
												@update:modelValue="form.cdMadori1 = $event"
												ref="cdMadori1"
												tabindex="19" />
											<itemerror-message :groupId="'Madori1'"/>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り２</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.cdMadori2Lbl != null">{{ form.cdMadori2Lbl }}</label>
											<label v-else class="hidden-word">間取り２</label>
										</div>
										<div v-show="disp.cdMadori2Edit" class="marginTop22px">
											<list-box
												class="contents__input--select width-madori"
												:modelValue="form.cdMadori2"
												:name="'間取り２'"
												:groupId="'Madori'"
												:cdType="'L0020'"
												@update:modelValue="form.cdMadori2 = $event"
												ref="cdMadori2"
												tabindex="20" />
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り３</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.cdMadori3Lbl != null">{{ form.cdMadori3Lbl }}</label>
											<label v-else class="hidden-word">間取り３</label>
										</div>
										<div v-show="disp.cdMadori3Edit" class="marginTop22px">
											<list-box
												class="contents__input--select width-madori"
												:modelValue="form.cdMadori3"
												:name="'間取り３'"
												:groupId="'Madori'"
												:cdType="'L0020'"
												@update:modelValue="form.cdMadori3 = $event"
												ref="cdMadori3"
												tabindex="21" />
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り表示用
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.txMadoriLbl != null">{{ form.txMadoriLbl }}</label>
											<label v-else class="hidden-word">間取り表示用</label>
										</div>
										<div v-show="disp.txMadoriEdit" class="marginTop22px">
											<text-input
												class="contents__input--text input-number width-madorihyoji ime-inactive"
												:modelValue="form.txMadori"
												:maxLength="25"
												:textType="TEXTINPUT_TYPE.ALL"
												:name="'間取り表示用'"
												:groupId="'MadoriHyouji'"
												:requireFlg="true"
												@update:modelValue="form.txMadori = $event"
												ref="txMadori"
												tabindex="22" />
											<itemerror-message :groupId="'MadoriHyouji'"/>
										</div>
										<div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">25桁以内で入力してください。</p>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">専用面積
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.nuSenyoLowLbl != null && form.nuSenyoUprLbl != null">{{ form.nuSenyoLowLbl }}m&sup2; ～ {{ form.nuSenyoUprLbl }}m&sup2;</label>
											<label v-else-if="form.nuSenyoLowLbl != null && form.nuSenyoUprLbl == null">{{ form.nuSenyoLowLbl }}m&sup2;</label>
											<label v-else class="hidden-word">専用面積</label>
										</div>
										<div v-show="disp.nuSenyoEdit" class="marginTop22px">
											<number-input
												class="contents__input--text width-menseki-text input-number ime-inactive"
												:modelValue="form.nuSenyoLow"
												:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
												:name="'専用面積（下限）'"
												:groupId="'nuSenyo'"
												:requireFlg="true"
												:maxLength="2"
												@update:modelValue="form.nuSenyoLow = $event"
												ref="nuSenyoLow"
												tabindex="23"
											/>m&sup2;
											<label style="margin-right: 10px; margin-left: 10px;">～</label>
											<number-input
												class="contents__input--text width-menseki-text input-number ime-inactive"
												:modelValue="form.nuSenyoUpr"
												:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
												:name="'専用面積（上限）'"
												:groupId="'nuSenyo'"
												:maxLength="2"
												@update:modelValue="form.nuSenyoUpr = $event"
												ref="nuSenyoUpr"
												tabindex="24"
											/>m&sup2;
											<itemerror-message :groupId="'nuSenyo'"/>
										</div>
										<div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">2桁以内の整数で入力してください。</p>
													</div>
												</div>
											</div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">下限は必須です</p>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">建設年度
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.yyKensetuLowLbl != null && form.yyKensetuUprLbl != null">{{ form.yyKensetuLowLbl }}年 ～ {{ form.yyKensetuUprLbl }}年</label>
											<label v-else-if="form.yyKensetuLowLbl != null && form.yyKensetuUprLbl == null">{{ form.yyKensetuLowLbl }}年</label>
											<label v-else class="hidden-word">建設年度</label>
										</div>
										<div v-show="disp.yyKensetuEdit" class="marginTop22px">
											<number-input
												class="contents__input--text width-kensetu-text input-number ime-inactive"
												:modelValue="form.yyKensetuLow"
												:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
												:name="'建設年度（下限）'"
												:groupId="'yyKensetu'"
												:requireFlg="true"
												:maxLength="4"
												@update:modelValue="form.yyKensetuLow = $event"
												ref="yyKensetuLow"
												tabindex="25"
											/>年
											<label style="margin-right: 10px; margin-left: 10px;">～</label>
											<number-input
												class="contents__input--text width-kensetu-text input-number ime-inactive"
												:modelValue="form.yyKensetuUpr"
												:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
												:name="'建設年度（上限）'"
												:groupId="'yyKensetu'"
												:maxLength="4"
												@update:modelValue="form.yyKensetuUpr = $event"
												ref="yyKensetuUpr"
												tabindex="26"
											/>年
											<itemerror-message :groupId="'yyKensetu'"/>
										</div>
										<div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">下限は必須です</p>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">エレベーターの有無
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="elevatorUmu-title">
										<div class="marginTop15px">
											<label v-if="form.fgElevatorLbl != null">{{ form.fgElevatorLbl }}</label>
											<label v-else class="hidden-word">エレベーターの有無</label>
										</div>
										<div v-show="disp.fgElevatorEdit" class="marginTop22px">
											<div class="contents__input--toggle_btn margin-elevatorUmu">
												<toggle-button
													:classDiv="'padding__bottom-toggle'"
													:modelValue="form.fgElevator"
													:name="'エレベーターの有無'"
													:cdType="'L0004'"
													:groupId="'fgElevator'"
													:requireFlg="true"
													:radioGroupName="'fgElevator'"
													@update:modelValue="form.fgElevator = $event"
													ref="fgElevator"
													tabindex="27" />
												<itemerror-message :groupId="'fgElevator'"/>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">使用料
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.moSiyoryoLowLbl != null && form.moSiyoryoUprLbl != null">{{ co_commaSeparated(form.moSiyoryoLowLbl) }}円 ～ {{ co_commaSeparated(form.moSiyoryoUprLbl) }}円</label>
											<label v-else-if="form.moSiyoryoLowLbl != null && form.moSiyoryoUprLbl == null">{{ co_commaSeparated(form.moSiyoryoLowLbl) }}円</label>
											<label v-else class="hidden-word">使用料</label>
										</div>
										<div v-show="disp.moSiyoryoEdit" class="marginTop22px">
											<number-input
												class="contents__input--text width-siyoryo-text input-number ime-inactive"
												:modelValue="form.moSiyoryoLow"
												:numberType="NUMBERINPUT_TYPE.PERIOD"
												:name="'使用料（下限）'"
												:groupId="'moSiyoryo'"
												:requireFlg="true"
												:maxLength="6"
												@update:modelValue="form.moSiyoryoLow = $event"
												ref="moSiyoryoLow"
												tabindex="28"
											/>円
											<label style="margin-right: 10px; margin-left: 10px;">～</label>
											<number-input
												class="contents__input--text width-siyoryo-text input-number ime-inactive"
												:modelValue="form.moSiyoryoUpr"
												:numberType="NUMBERINPUT_TYPE.PERIOD"
												:name="'使用料（上限）'"
												:groupId="'moSiyoryo'"
												:requireFlg="true"
												:maxLength="6"
												@update:modelValue="form.moSiyoryoUpr = $event"
												ref="moSiyoryoUpr"
												tabindex="29"
											/>円
											<itemerror-message :groupId="'moSiyoryo'"/>
										</div>
										<div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">6桁以内の整数で入力してください。</p>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">仕様等</th>
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label v-if="form.txSiyouLbl != ''">{{ form.txSiyouLbl }}</label>
											<label v-else class="hidden-word">仕様等</label>
										</div>
										<div v-show="disp.txSiyouEdit" class="marginTop22px">
											<textarea-input
												class="contents__input--text width-textarea ime-active"
												:modelValue="form.txSiyou"
												:maxLength="70"
												:name="'仕様等'"
												:groupId="'txSiyou'"
												@update:modelValue="form.txSiyou = $event"
												ref="txSiyou"
												tabindex="30" />
											<itemerror-message :groupId="'txSiyou'"/>
										</div>
										<div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">70桁以内で入力してください。</p>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">バリアフリーの有無
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="busUmu-title">
										<div class="marginTop15px">
											<label v-if="form.fgBarrierfreeLbl != null">{{ form.fgBarrierfreeLbl }}</label>
											<label v-else class="hidden-word">バリアフリーの有無</label>
										</div>
										<div v-show="disp.fgBarrierfreeEdit" class="marginTop22px">
											<div class="contents__input--toggle_btn width-barrierfreeUmu">
												<toggle-button
													:classDiv="'padding__bottom-toggle'"
													:modelValue="form.fgBarrierfree"
													:name="'バリアフリーの有無'"
													:cdType="'L0005'"
													:groupId="'fgBarrierfree'"
													:requireFlg="true"
													:radioGroupName="'fgBarrierfree'"
													@update:modelValue="form.fgBarrierfree = $event"
													ref="fgBarrierfree"
													tabindex="31" />
												<itemerror-message :groupId="'fgBarrierfree'"/>
											</div>
										</div>
									</td>
								</tr>
								<tr v-if="form.jyutakuKind == '23'">
									<th class="contents__input--title padding__bottom-zero">事故内容
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.txJikonaiyoLbl != null">{{ form.txJikonaiyoLbl }}</label>
											<label v-else class="hidden-word">事故内容</label>
										</div>
										<div v-show="disp.txJikonaiyoEdit" class="marginTop22px">
											<textarea-input
												class="contents__input--text width-textarea ime-active"
												:modelValue="form.txJikonaiyo"
												:maxLength="40"
												:name="'事故内容'"
												:groupId="'txJikonaiyo'"
												:requireFlg="true"
												@update:modelValue="form.txJikonaiyo = $event"
												ref="txJikonaiyo"
												tabindex="32" />
											<itemerror-message :groupId="'txJikonaiyo'"/>
										</div>
										<div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">40桁以内で入力してください。</p>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
								<tr v-if="form.jyutakuKind == '23'">
									<th class="contents__input--title padding__bottom-zero">対象階
										<span v-show="disp.newHissuMark" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.txJikotaisyoLbl != null">{{ form.txJikotaisyoLbl }}</label>
											<label v-else class="hidden-word">対象階</label>
										</div>
										<div v-show="disp.txJikotaisyoEdit" class="marginTop22px">
											<text-input
												class="contents__input--text width-taisyo-text ime-active"
												:modelValue="form.txJikotaisyo"
												:textType="TEXTINPUT_TYPE.ALL"
												:name="'対象階'"
												:groupId="'txJikotaisyo'"
												:requireFlg="true"
												:maxLength="3"
												@update:modelValue="form.txJikotaisyo = $event"
												ref="txJikotaisyo"
												tabindex="33"
											/>
											<itemerror-message :groupId="'txJikotaisyo'"/>
										</div>
										<div>
											<div>
												<div class="contents__caution--div div_row contents__caution--multiple">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple ">※</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple ">3桁以内で入力してください。</p>
													</div>
												</div>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<br>
						<h2 class="contents__h2 zuiji__title">募集期間</h2>
						<table class="contents__table--stripe detail">
							<tbody>
								<tr>
									<th class="contents__input--title padding__bottom-zero">公開開始日時
										<span v-show="disp.dmKokaiSttHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero padding__bottom-date">
										<div class="marginTop15px">
											<label>{{ form.dmKokaiSttYear }}年{{ form.dmKokaiSttMonth }}月{{ form.dmKokaiSttDay }}日 {{ form.dmKokaiSttHour }}時{{ form.dmKokaiSttMin }}分</label>
										</div>
										<div v-show="disp.dmKokaiSttEdit" class="marginTop22px">
											<date-time-input
												:modelValue="form.dmKokaiStt"
												:name="'公開開始日時'"
												:dateType="DATETIME_KIND.KOKAI_START"
												:groupId="'dmKokaiStt'"
												:requireFlg="true"
												:disabledFlg="disp.dmKokaiSttDisabledFlg"
												@update:modelValue="form.dmKokaiStt = $event"
												ref="dmKokaiStt"
												tabindex="34" />
											<itemerror-message :groupId="'dmKokaiStt'"/>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">公開終了日時
										<span v-show="disp.dmKokaiEndHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero padding__bottom-date">
										<div class="marginTop15px">
											<label>{{ form.dmKokaiEndYear }}年{{ form.dmKokaiEndMonth }}月{{ form.dmKokaiEndday }}日 {{ form.dmKokaiEndHour }}時{{ form.dmKokaiEndMin }}分</label>
										</div>
										<div v-show="disp.dmKokaiEndEdit" class="marginTop22px">
											<date-time-input
												:modelValue="form.dmKokaiEnd"
												:name="'公開終了日時'"
												:dateType="DATETIME_KIND.KOKAI_END"
												:groupId="'dmKokaiEnd'"
												:requireFlg="true"
												@update:modelValue="form.dmKokaiEnd = $event"
												ref="dmKokaiEnd"
												tabindex="39" />
											<itemerror-message :groupId="'dmKokaiEnd'"/>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<br>
						<h2 class="contents__h2 zuiji__title">変更内容の反映日時</h2>
						<table class="contents__table--stripe detail">
							<tbody>
								<tr>
									<th class="contents__input--title padding__bottom-zero">変更反映日時
											<span v-show="disp.dmTekiyoSttHissu" class="contents__hissu">必須</span>
									</th>
									<td class="padding__top-zero padding__bottom-date">
										<div class="marginTop15px" v-show="disp.dmTekiyoSttLbl">
											<label v-if="form.dmTekiyoStt != null && disp.dmTekiyoSttDisabledFlg == false">{{ form.dmTekiyoSttYear }}年{{ form.dmTekiyoSttMonth }}月{{ form.dmTekiyoSttDay }}日 {{ form.dmTekiyoSttHour }}時{{ form.dmTekiyoSttMin }}分</label>
											<label v-else class="hidden-word">変更反映日時</label>
										</div>
										<div v-show="disp.dmTekiyoSttEdit" :class="disp.dmTekiyoSttDisabledFlg == true  ? 'marginTop6px' : 'marginTop22px'">
											<date-time-input
												:modelValue="form.dmTekiyoStt"
												:name="'変更反映日時'"
												:dateType="DATETIME_KIND.HENKO_HANEI"
												:groupId="'dmTekiyoStt'"
												:requireFlg="true"
												:disabledFlg="disp.dmTekiyoSttDisabledFlg"
												@update:modelValue="form.dmTekiyoStt = $event"
												ref="dmTekiyoStt"
												tabindex="44" />
											<itemerror-message :groupId="'dmTekiyoStt'"/>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<br>
						<div class="contents__div--center margin__bottom-page">
							<input
								v-show="disp.changebtn"
								type="button"
								value="変更"
								tabindex="49"
								class="contents__btn--confirm btn-kakunin"
								@click="clickChangeBtn">
							<input
								type="button"
								value="戻る"
								tabindex="50"
								ref="backBtn"
								class="contents__btn--cancel btn-modoru"
								@click="clickBackBtn">
						</div>
					</section>
				</div>
			</main>
		</div>
	</main>
</template>

<script>
import TextInput from '@/components/TextInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import ListBox from '@/components/ListBox.vue';
import RadioButton from '@/components/RadioButton.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import ToggleButton from '@/components/ToggleButton.vue';
import TextAreaInput from '@/components/TextAreaInput.vue';
import YearMonthInput from '@/components/YearMonthInput.vue';
import DateTimeInput from '@/components/DateTimeInput.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_confirmDialog } from '@/common/dialogUtility.js';
import { co_commaSeparated } from '@/common/stringUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_toTop, co_toTrans, co_clearParam } from '@/common/screenUtility.js';

import { NUMBERINPUT_TYPE, CD_HANDLE_TYPE, TEXTINPUT_TYPE, DATETIME_KIND, DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_ERROR_IS_ERRFLG, STORE_VIEW_PROGRESS, STORE_ERROR_SET_INPUT_ERR,
			STORE_DATA_DELETE_AT, STORE_DATA_GETDATA, STORE_DATA_ADD_DATA, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { PATH_BC052_INIT, PATH_BC052_NYUKYOLIST, PATH_BC052_BACK, PATH_BC052_CHECK } from '@/const/route.js';

export default {
	name: "BC052",
	components: {
		'text-input': TextInput,
		'number-input': NumberInput,
		'list-box': ListBox,
		'radio-button': RadioButton,
		'itemerror-message': ItemErrorMessage,
		'toggle-button': ToggleButton,
		'textarea-input': TextAreaInput,
		'year-month-input': YearMonthInput,
		'date-time-input': DateTimeInput,
		'error-message': ErrorMessage,
	},
	data: function () {
		return {
			form: {
				jyutakuKind: '',				// 住宅の種別
				jyutakuKindNm: '',				// 住宅の種別（名称）
				jyutakuKindBefore: '',			// 変更前住宅の種別コード値
				jyutakuKindLbl: '',				// 住宅の種別（戻るボタン押下時使用）
				ymBosyu: '',					// 公募年月
				ymBosyuLbl: '',					// 公募年月（戻るボタン押下時使用）
				ymBosyuYear: '',				// 公募年月（年）
				ymBosyuMonth: '',				// 公募年月（月）
				noMouchiku: '',					// 申込地区番号
				cdNyukyo: '',					// 入居人数
				kusibu: '',						// 区市部ラジオボタン
				lstKuSibu: '',					// 区市部
				cdDanchi: '',					// 団地区分
				txJyutakuName: '',				// 住宅名
				txKusicyo: '',					// 代表的な所在地
				txTrans: '',					// 主な交通機関
				kbToho: '',						// 徒歩区分
				nuToho: '',						// 駅・バス停からの徒歩時間
				fgbusRiyou: '',					// バスの利用有無
				nuBosyuKosu: '',				// 募集戸数
				cdMadori1: '',					// 間取り１
				cdMadori2: '',					// 間取り２
				cdMadori3: '',					// 間取り３
				txMadori: '',					// 間取り表示用
				nuSenyoLow: '',					// 専用面積（下限）
				nuSenyoUpr: '',					// 専用面積（上限）
				yyKensetuLow: '',				// 建設年度（下限）
				yyKensetuUpr: '',				// 建設年度（上限）
				fgElevator: '',					// エレベーターの有無
				moSiyoryoLow: '',				// 使用料（下限）
				moSiyoryoUpr: '',				// 使用料（上限）
				txSiyou: '',					// 仕様等
				fgBarrierfree: '',				// バリアフリーの有無
				txJikonaiyo: '',				// 事故内容
				txJikotaisyo: '',				// 対象階
				dmKokaiStt:'',					// 公開開始日時
				dmKokaiSttYear: '',				// 公開開始日時（年）
				dmKokaiSttMonth: '',			// 公開開始日時（月）
				dmKokaiSttDay: '',				// 公開開始日時（日）
				dmKokaiSttHour: '',				// 公開開始日時（時）
				dmKokaiSttMin: '',				// 公開開始日時（分）
				dmKokaiEnd:'',					// 公開終了日時
				dmKokaiEndYear:'',				// 公開終了日時（年）
				dmKokaiEndMonth:'',				// 公開終了日時（月）
				dmKokaiEndday:'',				// 公開終了日時（日）
				dmKokaiEndHour:'',				// 公開終了日時（時）
				dmKokaiEndMin:'',				// 公開終了日時（分）
				dmTekiyoStt:'',					// 変更反映日時
				dmTekiyoSttLbl: '',				// 変更反映日時（戻るボタン押下時使用）
				dmTekiyoSttYear:'',				// 変更反映日時（年）
				dmTekiyoSttMonth:'',			// 変更反映日時（月）
				dmTekiyoSttDay:'',				// 変更反映日時（日）
				dmTekiyoSttHour:'',				// 変更反映日時（時）
				dmTekiyoSttMin:'',				// 変更反映日時（分）
				zyokyo: '',						// 公開状況
				dmKoshinNichiji: '',			// 更新日時
				txMapLink: '',					// 外部マップサービスリンク
			},
			disp: {
				kusibuList: [],					// 区市部リスト
				cdNyukyoList: [],				// 入居人数リスト
				nyukyoCodeList: [],				// 入居人数コードリスト
				nyukyoNameList: [],				// 入居人数名称リスト
				dmKokaiSttDisabledFlg: false,	// 公開終了日時活性・非活性フラグ
				dmTekiyoSttDisabledFlg: false,	// 変更反映日時活性・非活性フラグ
				jutakuKindHissu: true,			// 住宅の種別の必須マーク制御
				jyutakuKindEdit: true,			// 住宅の種別項目制御
				ymBosyuHissu: true,				// 公募年月の必須マーク制御
				ymBosyuEdit: true,				// 公募年月項目制御
				cdNyukyoHissu: true,			// 入居人数の必須マーク制御
				cdNyukyoEdit: true,				// 入居人数項目制御
				cdKusicyosonHissu: true,		// 区市町の必須マーク制御
				cdKusicyosonEdit: true,			// 区市町項目制御
				cdDanchiHissu: true,			// 団地区分の必須マーク制御
				cdDanchiEdit: true,				// 団地区分項目制御
				txJutakuNameHissu: true,		// 住宅名の必須マーク制御
				txJutakuNameEdit: true,			// 住宅名項目制御
				txKusicyoHissu: true,			// 代表的な所在地の必須マーク制御
				txKusicyoEdit: true,			// 代表的な所在地項目制御
				txTransEdit: true,				// 主な交通機関項目制御
				kbTohoEdit: true,				// 徒歩区分項目制御
				nuTohoEdit: true,				// 駅・バス停からの徒歩時間項目制御
				fgbusRiyouEdit: true,			// バス利用の有無項目制御
				nuBosyuKosuEdit: true,			// 募集戸数項目制御
				cdMadori1Edit: true,			// 間取り１項目制御
				cdMadori2Edit: true,			// 間取り２項目制御
				cdMadori3Edit: true,			// 間取り３項目制御
				txMadoriEdit: true,				// 間取り表示用項目制御
				nuSenyoEdit : true,				// 専用面積項目制御
				yyKensetuEdit: true,			// 建設年度項目制御
				fgElevatorEdit: true,			// エレベーターの有無項目制御
				moSiyoryoEdit: true,			// 使用料項目制御
				txSiyouEdit: true,				// 仕様等項目制御
				fgBarrierfreeEdit: true,		// バリアフリーの有無項目制御
				txJikonaiyoEdit: true,			// 事故内容項目制御
				txJikotaisyoEdit: true,			// 対象階項目制御
				dmKokaiSttHissu: true,			// 公開開始日時の必須マーク制御
				dmKokaiSttEdit: true,			// 公開開始日時項目制御
				dmKokaiEndHissu: true,			// 公開終了日時の必須マーク制御
				dmKokaiEndEdit: true,			// 公開終了日時項目制御
				dmTekiyoSttHissu: true,			// 変更反映日時の必須マーク制御
				dmTekiyoSttLbl: true,			// 変更反映日時（表示用）制御
				newHissuMark: true,				// 新必須項目必須マーク制御
				dmTekiyoSttEdit: true,			// 変更反映日時項目制御
				changebtn: true,				// 変更ボタン制御
				txMapLinkEdit: true,			// 外部マップサービスリンク制御
				mapLinkErrFlg: false,			// 外部マップサービスリンクエラーフラグ
			},
			bosyuKind: '',		// 募集の種類
			jyutakuKind: '',	// 住宅の種別
			ymBosyu: '',		// 公募年月
			noMouchiku: '',		// 申込地区番号
			tekiyokaishi: '',	// 変更反映日時
			zyokyo: '',			// 状況
			co_commaSeparated: co_commaSeparated,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			CD_HANDLE_TYPE: CD_HANDLE_TYPE,
			DATETIME_KIND: DATETIME_KIND
		}
	},
	created: async function() {

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 遷移元画面からのパラメータを取得
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC052');
		this.bosyuKind = params.bosyuKind;
		this.jyutakuKind = params.jyutakuKind;
		this.ymBosyu = params.ymBosyu;
		this.noMouchiku = params.noMouchiku;
		this.tekiyokaishi = params.tekiyokaishi;
		this.zyokyo = params.zyokyo;

		// 住宅の種別をパラメータから取得
		this.form.jyutakuKind = this.jyutakuKind;

		// 公募年月をパラメータから取得
		this.form.ymBosyu = this.ymBosyu;

		// 申込地区番号をパラメータから取得
		this.form.noMouchiku = this.noMouchiku;

		// 変更反映日時をパラメータから取得
		this.form.dmTekiyoStt = this.tekiyokaishi;

		// 状況をパラメータから取得
		this.form.zyokyo = this.zyokyo;

		// 画面間パラメータを削除
		co_clearParam('BC052');

		// 随時募集住宅情報取得（初期値取得）
		let initData = await co_post(PATH_BC052_INIT, this.form);

		// 前回の入力値確認
		let data = this.$store.getters[STORE_DATA_GETDATA]('BC052');

		if (data != null) {
			// 入力値設定
			this.form = data;
			this.$refs.ymBosyu.setValue(this.form.ymBosyu);
			this.$refs.dmKokaiStt.setValue(this.form.dmKokaiStt);
			this.$refs.dmKokaiEnd.setValue(this.form.dmKokaiEnd);
			this.$refs.dmTekiyoStt.setValue(this.form.dmTekiyoStt);
		} else {
			// 初期値設定
			// 変更前住宅の種別コード値（パラメータから設定）
			this.form.jyutakuKindBefore = this.jyutakuKind;
			// 住宅の種別（表示用）
			this.form.jyutakuKindNm = initData.nmZyutaku;
			// 公募年月（年）（表示用）
			this.form.ymBosyuYear = initData.ymBosyuYear;
			// 公募年月（月）（表示用）
			this.form.ymBosyuMonth = initData.ymBosyuMonth;
			// 公募年月
			this.form.ymBosyu = String(initData.ymBosyu);
			this.$refs.ymBosyu.setValue(this.form.ymBosyu);
			// 申込地区番号（表示用）
			this.form.noMouchikuLbl = this.noMouchiku;
			// 入居人数（表示用）
			this.form.cdNyukyoLbl = initData.nmNyukyo;
			// 入居人数
			this.form.cdNyukyo = initData.cdNyukyo;
			// 区市部（表示用）
			this.form.cdKusicyosonLbl = initData.nmKusicyoson;
			// 区市部ラジオボタン
			if (initData.nmKusicyoson.match(/区/)) {
				this.form.kusibu = '1';	// 「区」を設定
			} else {
				this.form.kusibu = '2';	// 「市」を設定
			}
			// 区市部
			this.form.lstKuSibu = initData.lstKuSibu;
			// 団地区分（表示用）
			this.form.cdDanchiLbl = initData.cdDanchi;
			// 団地区分
			this.form.cdDanchi = initData.cdDanchi;
			// 住宅名（表示用）
			this.form.txJyutakuNameLbl = initData.txJyutakuName;
			// 住宅名
			this.form.txJyutakuName = initData.txJyutakuName;
			// 代表的な所在地（表示用）
			this.form.txKusicyoLbl = initData.txKusicyo;
			// 代表的な所在地
			this.form.txKusicyo = initData.txKusicyo;
			// 主な交通機関（表示用）
			this.form.txTransLbl = initData.txTrans;
			// 主な交通機関
			this.form.txTrans = initData.txTrans;
			// 徒歩区分（表示用）
			this.form.kbTohoLbl = initData.nmToho;
			// 徒歩区分
			this.form.kbToho = initData.kbToho;
			// 駅・バス停からの徒歩時間（表示用）
			this.form.nuTohoLbl = initData.nuToho;
			// 駅・バス停からの徒歩時間
			this.form.nuToho = initData.nuToho;
			// バス利用の有無（表示用）
			this.form.fgbusRiyouLbl = initData.nmBusriyou;
			// バス利用の有無
			this.form.fgbusRiyou = initData.fgbusRiyou;
			// 募集戸数（表示用）
			if (initData.nuBosyuKosu == "" || initData.nuBosyuKosu == null) {
				this.form.nuBosyuKosuLbl = "0";
			} else {
				this.form.nuBosyuKosuLbl = initData.nuBosyuKosu;
			}
			// 募集戸数
			this.form.nuBosyuKosu = initData.nuBosyuKosu;
			// 間取り１（表示用）
			this.form.cdMadori1Lbl = initData.nmMadori1;
			// 間取り１
			this.form.cdMadori1 = initData.cdMadori1;
			// 間取り２（表示用）
			this.form.cdMadori2Lbl = initData.nmMadori2;
			// 間取り２
			this.form.cdMadori2 = initData.cdMadori2;
			// 間取り３（表示用）
			this.form.cdMadori3Lbl = initData.nmMadori3;
			// 間取り３
			this.form.cdMadori3 = initData.cdMadori3;
			// 間取り表示用（表示用）
			this.form.txMadoriLbl = initData.txMadori;
			// 間取り表示用
			this.form.txMadori = initData.txMadori;
			// 専用面積（下限）（表示用）
			this.form.nuSenyoLowLbl = initData.nuSenyoLow;
			// 専用面積（下限）
			this.form.nuSenyoLow = initData.nuSenyoLow;
			// 専用面積（上限）（表示用）
			this.form.nuSenyoUprLbl = initData.nuSenyoUpr;
			// 専用面積（上限）
			this.form.nuSenyoUpr = initData.nuSenyoUpr;
			// 建設年度（下限）（表示用）
			this.form.yyKensetuLowLbl = initData.yyKensetuLow;
			// 建設年度（下限）
			this.form.yyKensetuLow = initData.yyKensetuLow;
			// 建設年度（上限）（表示用）
			this.form.yyKensetuUprLbl = initData.yyKensetuUpr;
			// 建設年度（上限）
			this.form.yyKensetuUpr = initData.yyKensetuUpr;
			// エレベーターの有無（表示用）
			this.form.fgElevatorLbl = initData.nmElevator;
			// エレベーターの有無
			this.form.fgElevator = initData.fgElevator;
			// 使用料（下限）（表示用）
			this.form.moSiyoryoLowLbl = initData.moSiyoryoLow;
			// 使用料（下限）
			this.form.moSiyoryoLow = initData.moSiyoryoLow;
			// 使用料（上限）（表示用）
			this.form.moSiyoryoUprLbl = initData.moSiyoryoUpr;
			// 使用料（上限）
			this.form.moSiyoryoUpr = initData.moSiyoryoUpr;
			// 仕様等（表示用）
			this.form.txSiyouLbl = initData.txSiyou;
			// 仕様等
			this.form.txSiyou = initData.txSiyou;
			// バリアフリーの有無（表示用）
			this.form.fgBarrierfreeLbl = initData.nmBarrierfree;
			// バリアフリーの有無
			this.form.fgBarrierfree = initData.fgBarrierfree;
			// 事故内容（表示用）
			this.form.txJikonaiyoLbl = initData.txJikonaiyo;
			// 事故内容
			this.form.txJikonaiyo = initData.txJikonaiyo;
			// 対象階（表示用）
			this.form.txJikotaisyoLbl = initData.txJikotaisyo;
			// 対象階
			this.form.txJikotaisyo = initData.txJikotaisyo;
			// 公開開始日時（年）（表示用）
			this.form.dmKokaiSttYear = initData.dmKokaiSttYear;
			// 公開開始日時（月）（表示用）
			this.form.dmKokaiSttMonth = initData.dmKokaiSttMonth;
			// 公開開始日時（日）（表示用）
			this.form.dmKokaiSttDay = initData.dmKokaiSttDay;
			// 公開開始日時（時）（表示用）
			this.form.dmKokaiSttHour = initData.dmKokaiSttHour;
			// 公開開始日時（分）（表示用）
			this.form.dmKokaiSttMin = initData.dmKokaiSttMin;
			// 公開開始日時
			let dmKokaiSttFull = initData.dmKokaiSttYear + initData.dmKokaiSttMonth + initData.dmKokaiSttDay
									+ initData.dmKokaiSttHour + initData.dmKokaiSttMin;
			this.form.dmKokaiStt = String(dmKokaiSttFull);
			this.$refs.dmKokaiStt.setValue(this.form.dmKokaiStt);
			// 公開終了日時（年）（表示用）
			this.form.dmKokaiEndYear = initData.dmKokaiEndYear;
			// 公開終了日時（月）（表示用）
			this.form.dmKokaiEndMonth = initData.dmKokaiEndMonth;
			// 公開終了日時（日）（表示用）
			this.form.dmKokaiEndday = initData.dmKokaiEndday;
			// 公開終了日時（時）（表示用）
			this.form.dmKokaiEndHour = initData.dmKokaiEndHour;
			// 公開終了日時（分）（表示用）
			this.form.dmKokaiEndMin = initData.dmKokaiEndMin;
			// 公開終了日時
			let dmKokaiEndFull = initData.dmKokaiEndYear + initData.dmKokaiEndMonth + initData.dmKokaiEndday
									+ initData.dmKokaiEndHour + initData.dmKokaiEndMin;
			this.form.dmKokaiEnd = String(dmKokaiEndFull);
			this.$refs.dmKokaiEnd.setValue(this.form.dmKokaiEnd);
			// 変更反映日時（年）（表示用）
			this.form.dmTekiyoSttYear = initData.dmTekiyoSttYear;
			// 変更反映日時（月）（表示用）
			this.form.dmTekiyoSttMonth = initData.dmTekiyoSttMonth;
			// 変更反映日時（日）（表示用）
			this.form.dmTekiyoSttDay = initData.dmTekiyoSttDay;
			// 変更反映日時（時）（表示用）
			this.form.dmTekiyoSttHour = initData.dmTekiyoSttHour;
			// 変更反映日時（分）（表示用）
			this.form.dmTekiyoSttMin = initData.dmTekiyoSttMin;
			// 変更反映日時
			let dmTekiyoSttFull = initData.dmTekiyoSttYear + initData.dmTekiyoSttMonth + initData.dmTekiyoSttDay
									+ initData.dmTekiyoSttHour + initData.dmTekiyoSttMin;
			this.form.dmTekiyoStt = String(dmTekiyoSttFull);
			this.$refs.dmTekiyoStt.setValue(this.form.dmTekiyoStt);
			// 更新日時
			this.form.dmKoshinNichiji = initData.dmKoshinNichiji;
			// 外部マップサービスのリンク先（表示用）
			this.form.txMapLinkLbl = initData.txMapLink;
			// 外部マップサービスのリンク先
			this.form.txMapLink = initData.txMapLink;
		}

		// 項目制御（表示・非表示）
		let sysDate = new Date(initData.sysDateYear, initData.sysDateMonth, initData.sysDateDay, initData.sysDateHour, initData.sysDateMinute);
		let kokaiStt = new Date(this.form.dmKokaiSttYear, this.form.dmKokaiSttMonth, this.form.dmKokaiSttDay, this.form.dmKokaiSttHour, this.form.dmKokaiSttMin);
		let kokaiEnd = new Date(this.form.dmKokaiEndYear, this.form.dmKokaiEndMonth, this.form.dmKokaiEndday, this.form.dmKokaiEndHour, this.form.dmKokaiEndMin);
		// 公開開始日後の場合
		if (sysDate >= kokaiStt && sysDate < kokaiEnd) {
			// 変更予定データがない場合
			if (initData.henkoyoteiFlg == false) {
				this.disp.jutakuKindHissu = false;
				this.disp.jyutakuKindEdit = false;
				this.disp.ymBosyuHissu = false;
				this.disp.ymBosyuEdit = false;
				this.disp.cdKusicyosonHissu = false;
				this.disp.cdKusicyosonEdit = false;
				this.disp.cdDanchiHissu = false;
				this.disp.cdDanchiEdit = false;
				this.disp.txJutakuNameHissu = false;
				this.disp.txJutakuNameEdit = false;
				this.disp.dmKokaiSttHissu = false;
				// 項目制御（活性・非活性）
				this.disp.dmKokaiSttDisabledFlg = true;
				this.disp.dmTekiyoSttDisabledFlg = false;
			} else {	// 変更予定のデータがある場合
				this.disp.jutakuKindHissu = false;
				this.disp.jyutakuKindEdit = false;
				this.disp.ymBosyuHissu = false;
				this.disp.ymBosyuEdit = false;
				this.disp.cdNyukyoHissu = false;
				this.disp.cdNyukyoEdit = false;
				this.disp.cdKusicyosonHissu = false;
				this.disp.cdKusicyosonEdit = false;
				this.disp.cdDanchiHissu = false;
				this.disp.cdDanchiEdit = false;
				this.disp.txJutakuNameHissu = false;
				this.disp.txJutakuNameEdit = false;
				this.disp.txKusicyoHissu = false;
				this.disp.txKusicyoEdit = false;
				this.disp.txTransEdit = false;
				this.disp.kbTohoEdit = false;
				this.disp.nuTohoEdit = false;
				this.disp.fgbusRiyouEdit = false;
				this.disp.nuBosyuKosuEdit = false;
				this.disp.cdMadori1Edit = false;
				this.disp.cdMadori2Edit = false;
				this.disp.cdMadori3Edit = false;
				this.disp.txMadoriEdit = false;
				this.disp.nuSenyoEdit = false;
				this.disp.yyKensetuEdit = false;
				this.disp.fgElevatorEdit = false;
				this.disp.moSiyoryoEdit = false;
				this.disp.txSiyouEdit = false;
				this.disp.fgBarrierfreeEdit = false;
				this.disp.txJikonaiyoEdit = false;
				this.disp.txJikotaisyoEdit = false;
				this.disp.dmKokaiSttHissu = false;
				this.disp.dmKokaiSttEdit = false;
				this.disp.dmKokaiEndHissu = false;
				this.disp.dmKokaiEndEdit = false;
				this.disp.dmTekiyoSttHissu = false;
				this.disp.dmTekiyoSttLbl = true;
				this.disp.dmTekiyoSttEdit = false;
				this.disp.newHissuMark = false;
				this.disp.changebtn = false;
				this.disp.txMapLinkEdit = false;
			}
		} else if (sysDate < kokaiStt && sysDate < kokaiEnd) { // 公開開始日前の場合
			this.disp.jutakuKindHissu = true;
			this.disp.jyutakuKindEdit = true;
			this.disp.ymBosyuHissu = true;
			this.disp.ymBosyuEdit = true;
			this.disp.cdNyukyoHissu = true;
			this.disp.cdNyukyoEdit = true;
			this.disp.cdKusicyosonHissu = true;
			this.disp.cdKusicyosonEdit = true;
			this.disp.cdDanchiHissu = true;
			this.disp.cdDanchiEdit = true;
			this.disp.txJutakuNameHissu = true;
			this.disp.txJutakuNameEdit = true;
			this.disp.txKusicyoHissu = true;
			this.disp.txKusicyoEdit = true;
			this.disp.txTransEdit = true;
			this.disp.kbTohoEdit = true;
			this.disp.nuTohoEdit = true;
			this.disp.fgbusRiyouEdit = true;
			this.disp.nuBosyuKosuEdit = true;
			this.disp.cdMadori1Edit = true;
			this.disp.cdMadori2Edit = true;
			this.disp.cdMadori3Edit = true;
			this.disp.txMadoriEdit = true;
			this.disp.nuSenyoEdit = true;
			this.disp.yyKensetuEdit = true;
			this.disp.fgElevatorEdit = true;
			this.disp.moSiyoryoEdit = true;
			this.disp.txSiyouEdit = true;
			this.disp.fgBarrierfreeEdit = true;
			this.disp.txJikonaiyoEdit = true;
			this.disp.txJikotaisyoEdit = true;
			this.disp.dmKokaiSttHissu = true;
			this.disp.dmKokaiSttEdit = true;
			this.disp.dmKokaiEndHissu = true;
			this.disp.dmKokaiEndEdit = true;
			this.disp.dmTekiyoSttHissu = false;
			this.disp.dmTekiyoSttLbl = false;
			this.disp.dmTekiyoSttEdit = true;
			this.disp.newHissuMark = true;
			this.disp.changebtn = true;
			this.disp.txMapLinkEdit = true;
			// 項目制御（活性・非活性）
			this.disp.dmKokaiSttDisabledFlg = false;
			this.disp.dmTekiyoSttDisabledFlg = true;
			// 変更反映日時初期値初期化
			// 変更反映日時
			let dmTekiyoSttFull = "------------";
			this.form.dmTekiyoStt = String(dmTekiyoSttFull);
			this.$refs.dmTekiyoStt.setValue(this.form.dmTekiyoStt);
		} else if (sysDate >= kokaiEnd) { // 公開終了している住宅の場合
			this.disp.jutakuKindHissu = false;
			this.disp.jyutakuKindEdit = false;
			this.disp.ymBosyuHissu = false;
			this.disp.ymBosyuEdit = false;
			this.disp.cdNyukyoHissu = false;
			this.disp.cdNyukyoEdit = false;
			this.disp.cdKusicyosonHissu = false;
			this.disp.cdKusicyosonEdit = false;
			this.disp.cdDanchiHissu = false;
			this.disp.cdDanchiEdit = false;
			this.disp.txJutakuNameHissu = false;
			this.disp.txJutakuNameEdit = false;
			this.disp.txKusicyoHissu = false;
			this.disp.txKusicyoEdit = false;
			this.disp.txTransEdit = false;
			this.disp.kbTohoEdit = false;
			this.disp.nuTohoEdit = false;
			this.disp.fgbusRiyouEdit = false;
			this.disp.nuBosyuKosuEdit = false;
			this.disp.cdMadori1Edit = false;
			this.disp.cdMadori2Edit = false;
			this.disp.cdMadori3Edit = false;
			this.disp.txMadoriEdit = false;
			this.disp.nuSenyoEdit = false;
			this.disp.yyKensetuEdit = false;
			this.disp.fgElevatorEdit = false;
			this.disp.moSiyoryoEdit = false;
			this.disp.txSiyouEdit = false;
			this.disp.fgBarrierfreeEdit = false;
			this.disp.txJikonaiyoEdit = false;
			this.disp.txJikotaisyoEdit = false;
			this.disp.dmKokaiSttHissu = false;
			this.disp.dmKokaiSttEdit = false;
			this.disp.dmKokaiEndHissu = false;
			this.disp.dmKokaiEndEdit = false;
			this.disp.dmTekiyoSttHissu = false;
			this.disp.dmTekiyoSttLbl = true;
			this.disp.dmTekiyoSttEdit = false;
			this.disp.newHissuMark = false;
			this.disp.changebtn = false;
			this.disp.txMapLinkEdit = false;
		}

		// 入居人数リスト取得
		let nyukyoListInfo = await co_post(PATH_BC052_NYUKYOLIST);
		// 入居人数リスト作成
		this.disp.cdNyukyoList = nyukyoListInfo;

		// 区市部設定
		this.disp.kusibuList = [
			{ idCd: '1', nmCd: '区部'},
			{ idCd: '2', nmCd: '市部'}
		];

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		if (this.zyokyo == "公開予定") {
			this.$refs.jyutakuKind.focus();
		} else if (this.zyokyo == "公開中" || this.zyokyo == "変更予定") {
			this.$refs.cdNyukyo.focus();
		}

		// ページトップへ遷移
		co_toTop();
	},
	methods: {
		// 住宅の種別リスト変更
		changeJyutakuKind: function (val) {
			this.form.jyutakuKind = val;

			// 居室内で病死等があった住宅で無い場合
			if (this.form.jyutakuKind != '23') {
				// 事故内容、対象階を初期化
				this.form.txJikonaiyo = '';
				this.form.txJikotaisyo = '';
			}
		},
		// 募集戸数＋ボタン押下
		clickPlus: function () {
			this.form.nuBosyuKosu = Number(this.form.nuBosyuKosu) < Number("999") ? String(Number(this.form.nuBosyuKosu) + 1) : this.form.nuBosyuKosu;
		},
		// 募集戸数－ボタン押下
		clickMinus: function () {
			this.form.nuBosyuKosu = Number(this.form.nuBosyuKosu) > Number("1") ? String(Number(this.form.nuBosyuKosu) - 1) : this.form.nuBosyuKosu;
		},

		// 変更ボタン押下
		clickChangeBtn: async function () {

			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 単項目チェック
			this.checkValidate();

			let inputError = false;

			// 住代表的な所在地妥当性チェック
			if (!co_isEmpty(this.form.txKusicyo)) {
				if (this.form.txKusicyo.indexOf('市') == -1
					&& this.form.txKusicyo.indexOf('区') == -1
					&& this.form.txKusicyo.indexOf('町') == -1) {

					// 住代表的な所在地妥当性エラー
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'txKusicyo', msg: co_getMessage('E0116')});
					this.$refs.txKusicyo.setError();
					if (!inputError) this.$refs.txKusicyo.focus();
					inputError = true;
				}
			}

			// 募集戸数範囲チェック
			if (!co_isEmpty(this.form.nuBosyuKosu)) {
				
				if (Number(this.form.nuBosyuKosu) > 999 || Number(this.form.nuBosyuKosu) < 1) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nuBosyuKosu', msg: co_getMessage('E0056', '募集戸数', '1以上、999以下')});
					this.$refs.nuBosyuKosu.setError();
					if (!inputError) this.$refs.nuBosyuKosu.focus();
					inputError = true;
				}
			}

			// 専用面積大小チェック
			if (!co_isEmpty(this.form.nuSenyoLow) && !co_isEmpty(this.form.nuSenyoUpr)) {
				
				if (Number(this.form.nuSenyoLow) > Number(this.form.nuSenyoUpr)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nuSenyo', msg: co_getMessage('E0094', '専用面積')});
					this.$refs.nuSenyoLow.setError();
					this.$refs.nuSenyoUpr.setError();
					if (!inputError) this.$refs.nuSenyoLow.focus();
					inputError = true;
				}
			}

			// 建設年度大小チェック
			if (!co_isEmpty(this.form.yyKensetuLow) && !co_isEmpty(this.form.yyKensetuUpr)) {
				
				if (Number(this.form.yyKensetuLow) > Number(this.form.yyKensetuUpr)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'yyKensetu', msg: co_getMessage('E0094', '建設年度')});
					this.$refs.yyKensetuLow.setError();
					this.$refs.yyKensetuUpr.setError();
					if (!inputError) this.$refs.yyKensetuLow.focus();
					inputError = true;
				}
			}

			// 使用料大小チェック
			if (!co_isEmpty(this.form.moSiyoryoLow) && !co_isEmpty(this.form.moSiyoryoUpr)) {
				
				if (Number(this.form.moSiyoryoLow) > Number(this.form.moSiyoryoUpr)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'moSiyoryo', msg: co_getMessage('E0094', '使用料')});
					this.$refs.moSiyoryoLow.setError();
					this.$refs.moSiyoryoUpr.setError();
					if (!inputError) this.$refs.moSiyoryoLow.focus();
					inputError = true;
				}
			}

			// 公開開始日時 ＞ 公開終了日時 の場合
			if (!co_isEmpty(this.form.dmKokaiStt) && !co_isEmpty(this.form.dmKokaiEnd)) {
				if (this.form.dmKokaiStt > this.form.dmKokaiEnd) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'dmKokaiStt', msg: co_getMessage('E0094', '公開開始日時と公開終了日時')});
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'dmKokaiEnd', msg: co_getMessage('E0094', '公開開始日時と公開終了日時')});
					this.$refs.dmKokaiStt.setError();
					this.$refs.dmKokaiEnd.setError();
					if (!inputError) this.$refs.dmKokaiStt.focus();
					inputError = true;
				}
			}

			// 変更反映日時 ＞ 公開終了日時 の場合
			if (!co_isEmpty(this.form.dmTekiyoStt) && !co_isEmpty(this.form.dmKokaiEnd)) {
				if (this.form.dmTekiyoStt > this.form.dmKokaiEnd) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'dmTekiyoStt', msg: co_getMessage('E0094', '公開終了日時と変更反映日時')});
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'dmKokaiEnd', msg: co_getMessage('E0094', '公開終了日時と変更反映日時')});
					this.$refs.dmTekiyoStt.setError();
					this.$refs.dmKokaiEnd.setError();
					if (!inputError) this.$refs.dmKokaiEnd.focus();
					inputError = true;
				}
			}

			// 外部マップサービスのリンク先存在チェック
			if (!co_isEmpty(this.form.txMapLink) && this.disp.mapLinkErrFlg) {
				let isExist = await co_post(PATH_BC052_CHECK, this.form);
				if (!isExist) {
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'txMapLink', msg: co_getMessage('E0137')});
					this.$refs.txMapLink.setError();
					if (!inputError) this.$refs.txMapLink.focus();
					inputError = true;
				}
			}

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				// 住宅情報変更内容確認（随時募集・管理者用）へ遷移する
				let params = { zyutakuInfo: this.form };
				co_toTrans('BC053', params);
			}

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC052', data: this.form });
		},

		// 戻るボタン押下
		clickBackBtn: async function () {

			// 単項目チェック
			this.checkBackValidate();

			// 入力チェックエラーが存在ある場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				
				// エラークリア
				this.$store.commit(STORE_ERROR_CLEAR);

				// 確認ダイアログ表示
				co_confirmDialog(co_getMessage("W0016"), this.doBack);
				return;
			} else {

				// 住宅の種別をパラメータから取得
				this.form.jyutakuKindLbl = this.jyutakuKind;

				// 公募年月をパラメータから取得
				this.form.ymBosyuLbl = this.ymBosyu;

				// 申込地区番号をパラメータから取得
				this.form.noMouchiku = this.noMouchiku;

				// 変更反映日時をパラメータから取得
				this.form.dmTekiyoSttLbl = this.tekiyokaishi;

				// 状況をパラメータから取得
				this.form.zyokyo = this.zyokyo;

				let comparisonResult = await co_post(PATH_BC052_BACK, this.form);
				// 随時募集住宅情報に変更がある場合
				if (comparisonResult.hikakuFlg == true && "公開終了" != this.zyokyo) {
					// 確認ダイアログ表示
					co_confirmDialog(co_getMessage("W0016"), this.doBack);
					return;
				} else {
					// 画面の状態管理情報を削除
					this.$store.commit(STORE_DATA_DELETE_AT, 'BC052');

					// 住宅一覧（随時募集・管理者用）へ遷移する
					co_toTrans('BC051');
				}
			}

		},
		// 確認ダイアログ「はい」ボタン押下時処理
		doBack: async function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 画面の状態管理情報を削除
				this.$store.commit(STORE_DATA_DELETE_AT, 'BC052');

				// 住宅一覧（随時募集・管理者用）へ遷移する
				co_toTrans('BC051');
			}
			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},
		// 単項目チェック
		checkValidate: function () {

			this.$refs.jyutakuKind.validate();
			this.$refs.ymBosyu.validate();
			this.$refs.cdNyukyo.validate();
			this.$refs.kusibu.validate();
			this.$refs.lstKuSibu.validate();
			this.$refs.cdDanchi.validate();
			this.$refs.txJyutakuName.validate();
			this.$refs.txKusicyo.validate();
			this.$refs.txTrans.validate();
			this.$refs.kbToho.validate();
			this.$refs.nuToho.validate();
			this.$refs.fgbusRiyou.validate();
			this.$refs.nuBosyuKosu.validate();
			this.$refs.cdMadori1.validate();
			this.$refs.txMadori.validate();
			this.$refs.nuSenyoLow.validate();
			this.$refs.nuSenyoUpr.validate();
			this.$refs.yyKensetuLow.validate();
			this.$refs.yyKensetuUpr.validate();
			this.$refs.fgElevator.validate();
			this.$refs.moSiyoryoLow.validate();
			this.$refs.moSiyoryoUpr.validate();
			this.$refs.txSiyou.validate();
			this.$refs.fgBarrierfree.validate();
			if (this.form.jyutakuKind == '23') {
				// 居室内で病死等があった住宅の場合
				this.$refs.txJikonaiyo.validate();
				this.$refs.txJikotaisyo.validate();
			}
			this.$refs.dmKokaiStt.validate();
			this.$refs.dmKokaiEnd.validate();
			if (this.disp.dmTekiyoSttDisabledFlg == false) {
				this.$refs.dmTekiyoStt.validate();
			}
			this.disp.mapLinkErrFlg = this.$refs.txMapLink.validate();
		},
		// 単項目チェック（戻るボタン押下時）
		checkBackValidate: function () {

			this.$refs.jyutakuKind.validate();
			this.$refs.ymBosyu.validate();
			this.$refs.cdNyukyo.validate();
			this.$refs.kusibu.validate();
			this.$refs.lstKuSibu.validate();
			this.$refs.cdDanchi.validate();
			this.$refs.txJyutakuName.validate();
			this.$refs.txKusicyo.validate();
			this.$refs.txTrans.validate();
			this.$refs.kbToho.validate();
			this.$refs.nuToho.validate();
			this.$refs.nuBosyuKosu.validate();
			this.$refs.cdMadori1.validate();
			this.$refs.txMadori.validate();
			this.$refs.nuSenyoLow.validate();
			this.$refs.nuSenyoUpr.validate();
			this.$refs.yyKensetuLow.validate();
			this.$refs.yyKensetuUpr.validate();
			this.$refs.moSiyoryoLow.validate();
			this.$refs.moSiyoryoUpr.validate();
			this.$refs.txSiyou.validate();
			this.$refs.txMapLink.validate();

			// エラー発生時の赤枠クリア
			this.$refs.jyutakuKind.clearError();
			this.$refs.ymBosyu.clearError();
			this.$refs.cdNyukyo.clearError();
			this.$refs.kusibu.clearError();
			this.$refs.lstKuSibu.clearError();
			this.$refs.cdDanchi.clearError();
			this.$refs.txJyutakuName.clearError();
			this.$refs.txKusicyo.clearError();
			this.$refs.txTrans.clearError();
			this.$refs.kbToho.clearError();
			this.$refs.nuToho.clearError();
			this.$refs.nuBosyuKosu.clearError();
			this.$refs.cdMadori1.clearError();
			this.$refs.txMadori.clearError();
			this.$refs.nuSenyoLow.clearError();
			this.$refs.nuSenyoUpr.clearError();
			this.$refs.yyKensetuLow.clearError();
			this.$refs.yyKensetuUpr.clearError();
			this.$refs.moSiyoryoLow.clearError();
			this.$refs.moSiyoryoUpr.clearError();
			this.$refs.txSiyou.clearError();
			this.$refs.txMapLink.clearError();

			// フォーカス制御
			this.$refs.backBtn.focus();
		},
	}
};
</script>

<style scoped>


.width-mouchiku {
	width: 75px;
}

.width-bosyuKosu {
	width: 40px;
}

.marginRight-bosyuKosu {
	margin-right: 5px;
}

.marginLeft-bosyuKosu {
	margin: 0 10px 0 5px;
}

.width-koubo,
.width-madori {
	width: auto;
}

.width-madorihyoji {
	width: 403px;
}

.label-line-height {
	line-height: 1.4em;
	margin-top: 4px;
	margin-bottom: -15px;
}

.width-textarea {
	width: -webkit-fill-available;
}

.width-toho-text,
.width-menseki-text,
.width-kensetu-text {
	width: 50px;
	margin-right: 10px;
	text-align: right;
}

.width-taisyo-text {
	width: 50px;
	margin-right: 10px;
}

.width-siyoryo-text {
	width: 75px;
	margin-right: 10px;
	text-align: right;
}

.width-jikonaiyo-text {
	width: 90%;
}

.padding__bottom-date {
	padding-bottom: 20px !important;
}

.marginTop15px {
	margin-top: 15px;
}

.marginTop22px {
	margin-top: 22px;
}

.marginTop6px {
	margin-top: 6px;
}

.hidden-word {
	color:transparent;
	user-select: none;
}

.contents__main {
	margin-left: 1% !important;
	margin-right: 1% !important;
}

.contents__input-main {
	margin-top: -2%;
}

.contents__table--stripe td {
	line-height: 0px;
}

.bosyujyutaku__title {
	margin-top: 1% !important;
	margin-bottom: 1% !important;
}

.width-bosyu-kind {
	padding-top: 25px !important;
}

.zuiji__title {
	margin-top: 2% !important;
	margin-bottom: 1% !important;
}

.btn-kakunin {
	margin-bottom: 2%;
}

.btn-modoru {
	margin-left: 1%;
}

.contents__hissu {
	right: 1%;
}

.width-kushicyo {
	margin-top: 20px;
	margin-bottom: 5px;
}

.width-jyutaku-text,
.width-kushicyo-text {
	width: 83%;
}

.textalign-dantikubun {
	text-align: left !important;
}

.padding__bottom-toggle {
	padding-bottom: 60px !important;
}
</style>